export default __webpack_public_path__ + "static/media/Frame_195.70b65c1d.jpg";